import {useState} from "react";
import "./TabsSelector.scss";

/**
 * @param {{title: string, content, display: boolean}[]} children
 * @param {false|number} selection
 * @return {JSX.Element}
 * @constructor
 */
const TabsSelector = ({children, selection = false, onSelectionChange = () => {}}) => {
    const [activeTabIndex, setActiveTabIndex] = useState(selection);

    const usedChildren = children.filter(it => it.display);

    const activeTab = usedChildren.filter((it, i) => i === activeTabIndex);

    return (
        <div className={`menu-root`}>
            <div className={"topMenuContainer"}>
                {usedChildren.map(
                    (item, i) => (
                        <label className={`topMenuKey ${i === activeTabIndex ? "active" : ""}`} key={i} onClick={() => {
                            if (selection === false && i === activeTabIndex) {
                                setActiveTabIndex(false);
                            } else {
                                setActiveTabIndex(i);
                            }

                            onSelectionChange();
                        }}>
                            <span>
                                {item.title}
                            </span>
                        </label>
                    ))}
            </div>
            <div className={"topMenuPayload"}>
                {activeTab.map(
                    (item, i) => (
                        // <div className={`topMenuItem ${i === activeTabIndex ? "active" : ""}`} key={i}>
                            item.content
                        // </div>
                    ))}
            </div>
        </div>
    );
}

export default TabsSelector;